module.exports = __webpack_public_path__ + "assets/1da3dc1daff7416b75c3fb1fa2b062f0.mp3";